import { render, staticRenderFns } from "./QueueCard.vue?vue&type=template&id=6b1fc568&scoped=true&"
import script from "./QueueCard.vue?vue&type=script&lang=js&"
export * from "./QueueCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1fc568",
  null
  
)

export default component.exports